/* Copyright (c) 2017 Backpack Health LLC */

const AddMenuPhrases = {
  sourceMenu: {
    backpackChoice: (isMainProfile, profileName) => ({
      id: isMainProfile ? 'list.fileSource.backpack.name' : 'list.fileSource.notUserBackpack.name',
      values: {
        string1: profileName,
      },
    }),
  },

};

export default AddMenuPhrases;
